import { render, staticRenderFns } from "./insert-widget-fields.vue?vue&type=template&id=2d4d16af&"
import script from "./insert-widget-fields.vue?vue&type=script&lang=tsx&"
export * from "./insert-widget-fields.vue?vue&type=script&lang=tsx&"
import style0 from "./insert-widget-fields.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports